export const formInitialValues = {
  commodityCode: null,
  commodityDescription: '',
  commercialDescription: '',
  manufacturerName: '',
  countryOfOriginCode: null,
  packageNumber: '',
  packageTypeCode: null,
  packageMark: '',
  grossMass: '',
  netMass: '',
  quotaType: null,
  requestedAmount: '',
  approvedAmount: '',
  requestedUomCode: null,
  approvedUomCode: null,
  remainingAmount: '',
  itemInvoiceAmountInForeignCurrency: '',
  itemInvoiceAmountInNationalCurrency: '',
  packages: [],
  treatments: [],
  parentItemId: null,
};
